import variables from "theme/variables";
import { FunctionComponent, useEffect, useState } from "react";
import { CSSProperties } from "styled-components";
import S from "./styled";

type Props = {
  checked: boolean;
  label: string;
  onChecked: (checked: boolean) => any;
  style?: CSSProperties;
};

const Checkbox: FunctionComponent<Props> = ({ checked, label, onChecked, style }) => {
  const [isChecked, setChecked] = useState(checked || false);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  const onClick = () => {
    setChecked((prev) => {
      onChecked(!prev);

      return !prev;
    });
  };

  return (
    <S.Checkbox style={style} onClick={onClick}>
      <S.CheckboxInput>
        <input type="checkbox" name="checkbox" checked={isChecked} onChange={() => null} />
        <S.CheckboxControl>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden={true} focusable={false}>
            <path fill="none" stroke={variables.COLORS.TEXT} strokeWidth="3" d="M1.73 12.91l6.37 6.37L22.79 4.59" />
          </svg>
        </S.CheckboxControl>
      </S.CheckboxInput>
      <span className="radio__label">{label}</span>
    </S.Checkbox>
  );
};

export default Checkbox;
